import React from 'react';
import { startDateModStyles } from './StartDateMod.styles';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';

export const NewStartDate = ({ isModEdit }: { isModEdit: boolean }) => {
  const { classes } = startDateModStyles();
  const { control, formState: { errors }, clearErrors, setError } = useFormContext();
  const value: any = useWatch({ name: 'newStartDate' });
  const preEmpDate: any = useWatch({ name: 'newPreEmploymentDate' });

  const checkDateValidation = date => {
    if (!date || date.toString().length === 0) return 'Required';
    clearErrors('newStartDate');
    return null;
  };

  return (
    <Controller
      control={control}
      name={'newStartDate'}
      rules={{
        validate: checkDateValidation,
      }}
      render={({ field: { onChange, ...rest } }) => {
        const newStartDate = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  if (preEmpDate && moment(setTo) > moment(preEmpDate)) {
                    clearErrors('newPreEmploymentDate');
                  }
                  onChange(setTo);
                } else {
                  onChange(null);
                }
              }}
              value={value}
              onCancel={() => { }}
              clear
              open={false}
              variant="filled"
              single
              placeholder="New Start Date*"
              quickSelect={false}
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={!isModEdit}
              keepClickAwayVal={true}
              onInlineEdit={val => {
                const fieldValue = val.substring(0, val.length - 1);
                if (!value && !moment(fieldValue).isValid()) {
                  setError('newStartDate', {
                    type: 'validate',
                    message: 'Invalid Format',
                  })
                } else clearErrors('newStartDate')
              }}
              initialDateRange={{
                startDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.newStartDate)}
              helperText={!isNullOrUndefined(errors?.newStartDate) ? errors?.newStartDate?.message : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
